import {useEffect, useState} from 'react'
import {VStack, HStack} from '@components/Stack'
import {useUser} from 'src/hooks/useUser'
import styles from 'src/Learn.module.css'
import {Text} from '@components/Text'
import {Modal} from '@components/Modal'
import {Button} from 'src/Button'
import {showConfetti} from 'src/utils'
import {Input} from 'src/Common'
import {Panel} from '@components/Panel'

export const FreeCourseModal = ({isOpen, onRequestClose}) => {
  const user = useUser()
  const [name, setName] = useState('')
  const [managerName, setManagerName] = useState('')
  const [managerEmail, setManagerEmail] = useState('')
  const [courseType, setCourseType] = useState('intermediate')
  const [isSent, setIsSent] = useState(false)

  function sendEmail() {
    showConfetti(1)
    setIsSent(true)
  }

  useEffect(() => {
    setName(user?.displayName || '')
  }, [user?.displayName])

  function getEmailLink() {
    return `mailto:${managerEmail}?subject=Approval for CSS Course&body=Hello ${managerName},<br>I am writing to request approval for enrolling in CSSBattle's Learn CSS (${courseType}) course (https://cssbattle.dev/learn) as part of our company's learning and development initiative. It will enhance my CSS skills and I believe this investment will help us make our websites more maintainable, robust and accessible to our users. This course has a one-time fee.<br><br>Thank you for considering my request. I look forward to your positive response.<br><br>Best regards,<br>${name}`.replace(
      /<br>/g,
      '%0D%0A'
    )
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Get the course for free!"
      size="content"
    >
      <VStack classes={styles.freeCourseContent}>
        <Text
          tag="h2"
          size={4}
          mono={false}
          appearance="primary"
          weight={600}
          a
        >
          Get the course for FREE!
        </Text>
        <p>
          Most companies have a budget for learning and development. So if you
          are a working professional, you can request your company this course
          through your company's budget. We also have a template letter for you
          below - just fill in the details and send it to your
          manager/boss/lead/HR.
        </p>

        {isSent ? (
          <p>We hope you get the approval soon! See you in the course 👋🏼</p>
        ) : (
          <div
            style={{
              maxInlineSize: '45ch',
            }}
          >
            <Panel onlyBorder={true}>
              <VStack gap="1rem" align="stretch">
                <Input
                  label="To"
                  value={managerEmail}
                  onChange={(e) => setManagerEmail(e.target.value)}
                  placeholder="<Manager's Email>"
                />
                <p>
                  Hello{' '}
                  <input
                    className={styles.letterInput}
                    placeholder={"<Manager's Name>"}
                    value={managerName}
                    onInput={(e) => setManagerName(e.target.value)}
                  />
                </p>
                <p>
                  I hope this email finds you well. I am writing to request
                  approval for enrolling in CSSBattle's Learn CSS (
                  <select
                    className={styles.letterInput}
                    value={courseType}
                    onChange={(e) => setCourseType(e.target.value)}
                  >
                    <option value="beginner">Beginner</option>
                    <option value="intermediate" selected>
                      Intermediate
                    </option>
                  </select>
                  ) (https://cssbattle.dev/learn) course as part of our
                  company's learning and development initiative. It will enhance
                  my CSS skills and I believe this investment will help us make
                  our websites more maintainable, robust and accessible to our
                  users. This course has a one-time fee.
                </p>

                <p>
                  Thank you for considering my request. I look forward to your
                  positive response.
                </p>
                <p>
                  Best regards
                  <br />
                  <input
                    className={styles.letterInput}
                    placeholder={"<Manager's Name>"}
                    value={name}
                    onInput={(e) => setName(e.target.value)}
                  />
                </p>
              </VStack>
            </Panel>
          </div>
        )}

        <HStack justify="center">
          {isSent ? (
            <Button onClick={() => setIsSent(false)}>
              Go back to the letter
            </Button>
          ) : (
            <a
              href={getEmailLink()}
              className="button button--primary"
              onClick={sendEmail}
            >
              Send email (opens your email client)
            </a>
          )}
        </HStack>
      </VStack>
    </Modal>
  )
}
